/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
import Cropper from 'cropperjs';
import './front.scss';

/* global cfgProductSizes */
/* global productAttributes */
/* global cropOrientations */
/* global imageOrientation */
/* global isCanvas */
/* global isPoster */
/* global productIdCategoryDefault */
/* global productVariantRef */

let x = 100;
let y = 100;
let cropper = '';
let isCropperReady = false;
const configuratorFormData = {};
let isWidthValid = true;
let isHeightValid = true;
let userSelectedOrientation = '';
let userSelectedSize = '';

// Visualizaitons default data
const frameWoodenWidth = 2; // cm
const frameAluminumWidth = 0.6; // cm
const passePartoutWidth = 10; // % of short edge
const imageCropOffsetPerSideForPP = 0.5; // cm

// Helper debounce function
function pixDebounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
}

function initCropperResize() {
  if ($('#product-pix-customization').hasClass('visible')) {
    initCropprer('refresh');
  }
}

const initCropperResizeDebounce = pixDebounce(initCropperResize, 200);
const initUpdateViewportHeightDebounce = pixDebounce(
  window?.updateViewportHeight,
  200,
);

function initProductCustomizationButton() {
  $('#start-customization').on('click', (e) => {
    window?.updateViewportHeight();

    $('#product-pix-customization').addClass('visible');
    $('body').addClass('noscroll');

    initCropprer('refresh');
    shuffleImageName();
    $('#variants').append($('.product-variants'));
  });
}

function initProductCustomizationCloseButton() {
  $('.product-pix-customization-close').on('click', (e) => {
    $('#add-to-cart-or-refresh').prepend($('.product-variants'));
    $('#product-pix-customization').removeClass('visible');
    $('.cropper-pre-wrapper').removeClass('ready');
    $('body').removeClass('noscroll');
  });
}

function initCropprer(type) {
  const image = document.getElementById('product-pix-customization-image');
  const addToCartButton = document.getElementById('add-to-cart');
  let configuratorForm = document.getElementById('configuratorFormData');

  //x = parseInt(cropperPreWrapper.getAttribute('data-default-crop-width'), 10);
  //y = parseInt(cropperPreWrapper.getAttribute('data-default-crop-height'), 10);

  if (type === 'refresh') {
    if (cropper) {
      isCropperReady = false;
      // Disable add to cart button while refreshing cropper
      addToCartButton.style.pointerEvents = 'none';
      addToCartButton.style.opacity = '0.5';

      //console.log('destroying cropper');
      cropper.destroy();
    }
  }

  //console.log('initializing new cropper');

  cropper = new Cropper(image, {
    viewMode: 1,
    initialAspectRatio: x / y,
    zoomable: false,
    dragMode: 'move',
    autoCropArea: 1,
    guides: false,
    center: false,
    cropBoxResizable: false,
    cropBoxMovable: false,
    modal: false,
    background: true,

    ready: function (event) {
      isCropperReady = true;
      cropper.enable();
      $('.cropper-pre-wrapper').addClass('ready');
      $('#ppbs-widget [data-dimensionname="width"] input').val(x);
      $('#ppbs-widget [data-dimensionname="height"] input')
        .val(y)
        .trigger('input')
        .trigger('change');

      customizeCropperArea(cropper);

      window.cropper = cropper;
    },

    crop(event) {
      let cropBoxData = cropper.getCropBoxData();
      let canvasData = cropper.getCanvasData();
      let initialImageData = cropper?.initialImageData;

      configuratorFormData.realSize = { x: x, y: y };

      let imageX = (cropBoxData.left - canvasData.left) / canvasData.width;
      let imageY = (cropBoxData.top - canvasData.top) / canvasData.height;
      let imageWidth = cropBoxData.width / canvasData.width;
      let imageHeight = cropBoxData.height / canvasData.height;

      configuratorFormData.imageSize = {
        x: imageX,
        y: imageY,
        width: imageWidth,
        height: imageHeight,
      };

      if (initialImageData) {
        const chosenDimensionsRatio = x / y;
        // the box is compared with the ratio it must have: the inner window for a passe-partout poster (before, its
        // outer ratio made every non-square passe-partout crop a mismatch)
        const windowRatioRounded =
          Math.round(cropWindowRatio(x, y) * 100) / 100; // rounding to 2 decimals
        const cropBoxRatio = cropBoxData.width / cropBoxData.height;
        const cropBoxRatioRounded = Math.round(cropBoxRatio * 100) / 100; // rounding to 2 decimals

        let cropRatioStatus = 'ok';

        if (windowRatioRounded !== cropBoxRatioRounded) {
          cropRatioStatus = 'mismatch';
        }

        configuratorFormData.initialImageData = initialImageData;
        configuratorFormData.cropBoxRatio = cropBoxRatio;
        configuratorFormData.chosenDimensionsRatio = chosenDimensionsRatio;
        configuratorFormData.cropRatioStatus = cropRatioStatus;
      }

      configuratorForm.value = JSON.stringify(configuratorFormData);
    },
  });
}

// The ratio of the crop box for a print of w × h cm: the whole print, or for a poster with passe-partout (variant
// reference with -PP) the inner window, the print less a passe-partout of passePartoutWidth % of its short side on
// every side.
function cropWindowRatio(w, h) {
  if (
    isPoster &&
    typeof productVariantRef === 'string' &&
    productVariantRef.includes('-PP')
  ) {
    const ppWidth = (passePartoutWidth / 100) * Math.min(w, h);

    return (w - ppWidth * 2) / (h - ppWidth * 2);
  }

  return w / h;
}

function customizeCropperArea(cropper) {
  let addToCartButton = document.getElementById('add-to-cart');

  x = parseInt($('#ppbs-widget [data-dimensionname="width"] input').val());
  y = parseInt($('#ppbs-widget [data-dimensionname="height"] input').val());

  updateVisualizationData(x, y);

  let cropBoxData = cropper.getCropBoxData();
  let canvasData = cropper.getCanvasData();

  let containerData = cropper.getContainerData();
  let containerWidth = containerData.width;
  let containerHeight = containerData.height;
  const chosenRatio = cropWindowRatio(x, y);

  let containerRatio = containerWidth / containerHeight;

  let canvasRatio = canvasData.width / canvasData.height;
  cropper.reset();

  // if(containerRatio > 1){
  //   if(canvasData.height > canvasData.width){
  //     canvasData.height = containerHeight;
  //     canvasData.width = canvasData.height*canvasRatio;
  //   } else {
  //     canvasData.width = containerHeight*1;
  //     canvasData.height = canvasData.width/canvasRatio;
  //   }
  // } else {
  //   if(canvasData.height > canvasData.width){
  //     canvasData.height = containerWidth;
  //     canvasData.width = canvasData.height*canvasRatio;
  //   } else {
  //     canvasData.width = containerWidth*1;
  //     canvasData.height = canvasData.width/canvasRatio;
  //   }
  // // }
  // canvasData.top = (containerHeight - canvasData.height)/2;
  // canvasData.left = (containerWidth - canvasData.width)/2;

  // cropper.setCropBoxData(canvasData);
  // cropper.setCanvasData(canvasData);

  // console.log(chosenRatio);
  // console.log(canvasRatio);
  // console.log(canvasData);
  // console.log(containerData);
  // console.log(cropBoxData);

  if (chosenRatio > canvasRatio) {
    cropBoxData.width = canvasData.width;
    cropBoxData.height = canvasData.width / chosenRatio;
    cropBoxData.top = (containerHeight - cropBoxData.height) / 2;
    cropBoxData.left = (containerWidth - cropBoxData.width) / 2;
  } else {
    cropBoxData.width = canvasData.height * chosenRatio;
    cropBoxData.height = canvasData.height;
    cropBoxData.top = (containerHeight - cropBoxData.height) / 2;
    cropBoxData.left = (containerWidth - cropBoxData.width) / 2;
  }

  cropper.setCropBoxData(cropBoxData);

  const canvas = document.getElementById('canvas-overlay');
  const ctx = canvas.getContext('2d');

  // console.log({ containerWidth, containerHeight });

  ctx.canvas.width = containerWidth;
  ctx.canvas.height = containerHeight;

  //var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  //var data = imgData.data;

  ctx.lineWidth = 1;
  ctx.translate(0.5, 0.5);

  // let lineY1 = parseInt(cropBoxData.top - canvasData.left);
  // let lineX1 = parseInt(cropBoxData.left - canvasData.left);

  // let lineY2 = parseInt(cropBoxData.top + cropBoxData.height + canvasData.left);
  // let lineX2 = parseInt(containerWidth - cropBoxData.left);

  //
  //
  // bline(lineX1, lineY1, parseInt(cropBoxData.left), parseInt(cropBoxData.top));
  // bline(containerWidth-lineX1, lineY1, lineX2, parseInt(cropBoxData.top));
  //
  // bline(lineX1, lineY2, parseInt(cropBoxData.left), parseInt(cropBoxData.top+cropBoxData.height));
  // bline(containerWidth-lineX1, lineY2, lineX2, parseInt(cropBoxData.top+cropBoxData.height));

  // ctx.putImageData(imgData, 0, 0);
  //
  // ctx.beginPath();
  // ctx.fillStyle = "#303030";
  //
  // ctx.moveTo(lineX1, lineY1);
  // ctx.lineTo(parseInt(cropBoxData.left), parseInt(cropBoxData.top));
  // ctx.moveTo(containerWidth-lineX1, lineY1);
  // ctx.lineTo(lineX2, parseInt(cropBoxData.top));
  // ctx.moveTo(lineX1, lineY2);
  // ctx.lineTo(parseInt(cropBoxData.left), parseInt(cropBoxData.top+cropBoxData.height));
  // ctx.moveTo(containerWidth-lineX1, lineY2);
  // ctx.lineTo(lineX2, parseInt(cropBoxData.top+cropBoxData.height));
  //
  //
  // ctx.moveTo(cropBoxData.left, cropBoxData.top - 20);
  // ctx.lineTo(cropBoxData.left+cropBoxData.width, cropBoxData.top - 20);
  // ctx.moveTo(cropBoxData.left, cropBoxData.top - 25);
  // ctx.lineTo(cropBoxData.left, cropBoxData.top - 15);
  // ctx.moveTo(cropBoxData.left+cropBoxData.width, cropBoxData.top - 25);
  // ctx.lineTo(cropBoxData.left+cropBoxData.width, cropBoxData.top - 15);
  //
  //
  // ctx.moveTo(cropBoxData.left+cropBoxData.width + 20, cropBoxData.top);
  // ctx.lineTo(cropBoxData.left+cropBoxData.width + 20, cropBoxData.top + cropBoxData.height);
  // ctx.moveTo(cropBoxData.left+cropBoxData.width + 25, cropBoxData.top);
  // ctx.lineTo(cropBoxData.left+cropBoxData.width + 15, cropBoxData.top);
  // ctx.moveTo(cropBoxData.left+cropBoxData.width + 25, cropBoxData.top + cropBoxData.height);
  // ctx.lineTo(cropBoxData.left+cropBoxData.width + 15, cropBoxData.top + cropBoxData.height);
  // ctx.stroke();
  //
  // ctx.fillStyle = "#f6f6f6";
  // let sizeBoxWidth = x.toString().length * 7 + 30;
  // ctx.roundRect(canvas.width/2-sizeBoxWidth/2,cropBoxData.top - 38,sizeBoxWidth,16, 8);
  //
  // let sizeBoxHeight = y.toString().length * 7 + 30;
  // ctx.roundRect(cropBoxData.left+cropBoxData.width + 28,canvas.height/2-sizeBoxHeight/2, 16 ,sizeBoxHeight, 8);
  // ctx.fill();
  //
  // ctx.fillStyle = "#000000";
  // ctx.font = '12px Inter';
  // ctx.textAlign = 'center';
  // ctx.textBaseline = 'middle';
  // ctx.fillText(x + ' cm', canvas.width/2, cropBoxData.top - 30);
  // ctx.save();
  //
  // ctx.fillStyle = "#000000";
  // ctx.font = '12px Inter';
  // ctx.textAlign = 'center';
  // ctx.textBaseline = 'middle';
  // ctx.translate(cropBoxData.left+cropBoxData.width + 36, canvas.height/2)
  // ctx.rotate(Math.PI / 2);
  // ctx.fillText(y + ' cm', 0, 0);
  // ctx.restore();
  // ctx.save();
  //

  // if x and y are valid numbers, update the area size display
  if (isNaN(x) || x == '') {
    isWidthValid = false;
  } else {
    isWidthValid = true;
  }

  if (isNaN(y) || y == '') {
    isHeightValid = false;
  } else {
    isHeightValid = true;
  }

  if (!isWidthValid || !isHeightValid) {
    addToCartButton.style.pointerEvents = 'none';
    addToCartButton.style.opacity = '0.5';
  } else {
    addToCartButton.style.pointerEvents = 'auto';
    addToCartButton.style.opacity = '1';
  }

  if (!isNaN(x) && !isNaN(y)) {
    $('#atc-ppbs-size').html((x * y) / 10000 + ' m<sup>2</sup>');
  } else {
    $('#atc-ppbs-size').html('--');
    $('#atc-ppbs-price').html('--');
  }

  //
  // ctx.setLineDash([4, 4]);
  // ctx.beginPath();
  // ctx.moveTo(parseInt(cropBoxData.left), lineY1);
  // ctx.lineTo(parseInt(cropBoxData.left), cropBoxData.top);
  // ctx.moveTo(parseInt(cropBoxData.left+cropBoxData.width), lineY1);
  // ctx.lineTo(parseInt(cropBoxData.left+cropBoxData.width), parseInt(cropBoxData.top));
  // ctx.moveTo(parseInt(cropBoxData.left), lineY2);
  // ctx.lineTo(parseInt(cropBoxData.left), parseInt(cropBoxData.top+cropBoxData.height));
  // ctx.moveTo(parseInt(cropBoxData.left+cropBoxData.width), lineY2);
  // ctx.lineTo(parseInt(cropBoxData.left+cropBoxData.width), parseInt(cropBoxData.top+cropBoxData.height));
  // ctx.stroke();
  //
  // if(x > 100){
  //   let lines = Math.ceil(x/100);
  //   let lineGap = cropBoxData.width/x*100;
  //   for(let i=1; i<lines; i++){
  //     ctx.moveTo(parseInt(cropBoxData.left+i*lineGap), lineY1);
  //     ctx.lineTo(parseInt(cropBoxData.left+i*lineGap), lineY2);
  //   }
  //   ctx.stroke();
  // }

  //
  // let ttA = heightTop;
  // let ttB = Math.abs(leftTop);
  // let ttC = Math.sqrt(ttA*ttA+ttB*ttB);
  // let ttLeft = ttB/2 - ttC/2;
  // let ttTop = '50%';
  //
  // if(chosenRatio > canvasRatio){
  //   ttA = canvasData.height/2 - cropBoxData.height/2;
  //   ttB = ($('.cropper-pre-wrapper').width()-cropBoxData.width)/2;
  //   ttC = Math.sqrt(ttA*ttA+ttB*ttB);
  //   ttLeft = (ttC - ttB)/2 - ttC;
  //   ttTop = $('.cropper-top').height() - (canvasData.height - cropBoxData.height)/4 + 'px';
  // }
  //
  // if(ttA < 60){
  //   ttA = 60;
  //   ttB = 60;
  //   ttC = Math.sqrt(ttA*ttA+ttB*ttB);
  //   ttLeft = -ttC + 10 + leftTop + 'px';
  //   ttTop = -ttA/2 + heightTop + 'px';
  // }
  //
  // let tlRotate = Math.asin(ttA/ttC) * (180 / Math.PI);
  //
  // let crsRight =  leftTop - cropBoxData.height/2 - 30;
  //
  // $('.cropper-top-size').innerWidth(cropBoxData.width).css({left: cropBoxData.left});
  // $('.cropper-top-size span.top-size').html(x + ' cm');
  // $('.cropper-right-size span.right-size').html(y + ' cm');
  // $('#atc-ppbs-size').html(x * y / 10000 + ' m<sup>2</sup>');
  // $('.cropper-right-size').innerWidth(cropBoxData.height).css({top: containerHeight/2 - 13, right: crsRight});
  // $('.cropper-top-left').innerWidth(ttC).css({top: 'calc( ' + ttTop + ' - 2px )', left: ttLeft, transform: 'rotate('+tlRotate+'deg)'});
  // $('.cropper-top-right').innerWidth(ttC).css({top: 'calc( ' + ttTop + ' - 2px )', right: ttLeft, transform: 'rotate(-'+tlRotate+'deg)'});
  // $('.cropper-bottom-left').innerWidth(ttC).css({bottom: 'calc( ' + ttTop + ' - 2px )', left: ttLeft, transform: 'rotate(-'+tlRotate+'deg)'});
  // $('.cropper-bottom-right').innerWidth(ttC).css({bottom: 'calc( ' + ttTop + ' - 2px )', right: ttLeft, transform: 'rotate('+tlRotate+'deg)'});
  // $('.cropper-bottom').innerHeight(heightTop).css({top: heightTop+cropBoxData.height});
  //
  // $('.cropper-cut-lines').append($('<span>').css({top: -60, left: 0}));
  // $('.cropper-cut-lines').append($('<span>').css({top: -60, right: 0}));
  // if(x > 100){
  //
  // }
}

function attachCropperListeners() {
  const cropperPreWrapper = document.querySelector('.cropper-pre-wrapper');
  const customizationLeftWrapper = document.querySelector(
    '.pix-customization-left-wrapper',
  );

  $('#ppbs-widget .product-field-wrapper input').on('input', function (e) {
    // Prevent non-numeric input
    let value = e.target.value;
    value = value.replace(/\D/g, '');
    e.target.value = value;

    //cropperPreWrapper.classList.remove('hovered');

    if (cropper) {
      customizeCropperArea(cropper);
    }
  });

  prestashop.on('updateCart', async (event) => {
    //console.log('updateCart event received in cropper listeners');
    //console.log(event);

    if (
      event.reason.linkAction == 'add-to-cart' /* ||
      event.reason.linkAction == 'delete-from-cart' */
    ) {
      if (event.reason.linkAction == 'add-to-cart') {
        const cropperReady = await waitForCropperReady();

        if (!cropperReady) {
          console.warn('Cropper is not ready yet, skipping image upload.');
        }
      }

      if (event.reason.linkAction == 'add-to-cart' && !cropper) {
        //console.info('No cropper instance found, skipping AJAX call');
        return;
      }

      if (!event.resp || !event.resp.id_customization) {
        console.warn(
          'pix_configurator: no id_customization in the updateCart response, skipping crop save',
        );
        return;
      }

      let formData = new FormData();

      formData.append('idCustomization', event.resp.id_customization);
      formData.append('cartAction', event.reason.linkAction);

      function makeAjaxCall(formData, attempt = 1) {
        const maxAttempts = 3;

        function retryOrGiveUp(reason) {
          if (attempt < maxAttempts) {
            setTimeout(function () {
              makeAjaxCall(formData, attempt + 1);
            }, 500 * attempt);
            return;
          }

          console.error('pix_configurator: could not save crop data', reason);
        }

        //console.log('Making AJAX call to save image with data:', formData);
        // Use `jQuery.ajax` method for example
        $.ajax(
          prestashop.urls.base_url +
            '/modules/pix_configurator/ajax.php?action=save_image',
          {
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success() {
              if (event.reason.linkAction == 'add-to-cart' && cropper) {
                console.log('Upload success');

                const refreshCartUrl = $('.js-cart').data('refresh-url');

                // Refresh cart again to show custom images
                $.getJSON(refreshCartUrl, function (resp) {
                  //console.log('Cart refreshed', resp);
                  $('#cartModal .js-cart').replaceWith(resp.cart_detailed);
                  prestashop.emit('updatedCart', { resp: resp });
                });
              } else {
                console.log('Remove success');
              }
            },
            error(e) {
              console.error(e);

              // 4xx answers are deterministic, retrying them cannot help.
              if (e && e.status >= 400 && e.status < 500) {
                console.error('pix_configurator: could not save crop data', e);
                return;
              }

              retryOrGiveUp(e);
            },
          },
        );
      }

      // Get dynamic photo data and add to form data /
      const dynamicPhotoData =
        document.getElementById('dynamicPhotoData')?.value;
      const dynamicPhotoId = document.getElementById('dynamicPhotoId')?.value;

      configuratorFormData.dynamicPhotoData = dynamicPhotoData;
      configuratorFormData.location = window.location.href;
      configuratorFormData.dynamicPhotoId = dynamicPhotoId;

      formData.append('croppedImageData', JSON.stringify(configuratorFormData));

      if (cropper) {
        let croppedCanvas = null;

        try {
          croppedCanvas = cropper.getCroppedCanvas();
        } catch (e) {
          // A tainted canvas throws here, the crop data must still be saved.
          console.warn(
            'pix_configurator: could not read the cropped canvas',
            e,
          );
        }

        if (!croppedCanvas) {
          // Make call without image if croppedCanvas is not available (can happen if cropper is not fully ready)
          makeAjaxCall(formData);
        } else {
          try {
            croppedCanvas.toBlob((blob) => {
              if (!blob) {
                console.warn(
                  'pix_configurator: empty cropped image, saving crop data only',
                );
                makeAjaxCall(formData);
                return;
              }

              // Pass the image file name as the third parameter if necessary.
              formData.append(
                'croppedImage',
                blob,
                configuratorFormData.imageName + '.png',
              );

              makeAjaxCall(formData);
            });
            shuffleImageName();
          } catch (e) {
            console.warn(
              'pix_configurator: could not export the cropped image',
              e,
            );
            makeAjaxCall(formData);
          }
        }
      } else {
        makeAjaxCall(formData);
      }
    } else {
      console.info(
        'Event reason is not add-to-cart, skipping event:',
        event?.reason?.linkAction,
      );
    }
  });

  $(cropperPreWrapper).on('click touchstart', function (e) {
    setTimeout(() => {
      cropperPreWrapper.classList.add('hovered');
      cropperPreWrapper
        .querySelector('.cropper-instructions')
        .classList.add('hovered');
    }, 400);
  });
}

function shuffleImageName() {
  let product_cropped_image = document.getElementById(
    'product_cropped_image',
  ).value;
  var shuffled = product_cropped_image
    .split('')
    .sort(function () {
      return 0.5 - Math.random();
    })
    .join('');

  configuratorFormData.imageName = shuffled;
  $('#product_cropped_image').val(shuffled);
}

function toggleDimensionSelects() {
  const $orientationSelect = $(
    '#product-pix-customization #predefined-orientation',
  );
  const $predifinedSizesVerticalSelect = $(
    '#product-pix-customization #predefined-sizes-vertical',
  );
  const $predifinedSizesHorizontalSelect = $(
    '#product-pix-customization #predefined-sizes-horizontal',
  );
  const $predifinedSizesSquareSelect = $(
    '#product-pix-customization #predefined-sizes-square',
  );

  $orientationSelect.on('change', (e) => {
    const selectedOrientation = e.target.value;

    userSelectedOrientation = selectedOrientation;

    $predifinedSizesVerticalSelect.removeClass('active');
    $predifinedSizesHorizontalSelect.removeClass('active');
    $predifinedSizesSquareSelect.removeClass('active');

    if (selectedOrientation === 'vertical') {
      $predifinedSizesVerticalSelect.addClass('active');
    } else if (selectedOrientation === 'horizontal') {
      $predifinedSizesHorizontalSelect.addClass('active');
    } else if (selectedOrientation === 'square') {
      $predifinedSizesSquareSelect.addClass('active');
    }

    // Find active select and update inputs
    let $activeSelect = $(
      '#product-pix-customization select.predefined-size.active',
    );
    updateInputFromSelect($activeSelect);
  });
}

function getDimensionsFromSelect($selectElement) {
  const selectedOption = $selectElement.find('option:selected');

  if (!selectedOption || selectedOption.length === 0) {
    return { x: null, y: null };
  }

  const selectedDimensions = selectedOption
    .val()
    .split('x')
    .map((v) => {
      //remove all non digit characters
      v = v.replace(/\D/g, '');
      return parseInt(v);
    });
  return {
    x: selectedDimensions[0],
    y: selectedDimensions[1],
  };
}

function updateVisualizationData(imageWidthInCm, imageHeightInCm) {
  //console.log('updating visualization data');

  if (!isCanvas && !isPoster) {
    return;
  }
  const $cropperPreWrapper = $('.cropper-pre-wrapper');
  const $cropperCropBox = $('.cropper-face');
  const cropperWrapperWidth = $cropperCropBox.width();
  const shortEdge = Math.min(imageWidthInCm, imageHeightInCm);
  const longEdge = Math.max(imageWidthInCm, imageHeightInCm);
  let passePartoutScaleFactor = 1;
  const ratio = imageWidthInCm / imageHeightInCm;

  // Calculate passe-partout width in cm
  const passePartoutWidthInCm = (passePartoutWidth / 100) * shortEdge;

  if (ratio > 1) {
    passePartoutScaleFactor = 1 - passePartoutWidthInCm / longEdge;
  }
  if (ratio < 1) {
    passePartoutScaleFactor = 1 - passePartoutWidthInCm / shortEdge;
  }

  function roundUpOdd(num) {
    let rounded = Math.ceil(num);
    return rounded % 2 === 0 ? rounded + 1 : rounded;
  }

  const frameWoodenWidthInPx = roundUpOdd(
    (frameWoodenWidth / imageWidthInCm) * cropperWrapperWidth,
  );
  const frameAluminumWidthInPx = roundUpOdd(
    (frameAluminumWidth / imageWidthInCm) * cropperWrapperWidth,
  );
  const passePartoutWidthInPx = roundUpOdd(
    (passePartoutWidthInCm / shortEdge) * cropperWrapperWidth,
  );
  const imageCropOffsetPerSideForPPInPx = roundUpOdd(
    (imageCropOffsetPerSideForPP / imageWidthInCm) * cropperWrapperWidth,
  );

  // console.log({
  //   imageWidthInCm,
  //   imageHeightInCm,
  //   cropperWrapperWidth,
  //   frameWoodenWidthInPx,
  //   frameAluminumWidthInPx,
  //   passePartoutWidthInPx,
  //   imageCropOffsetPerSideForPPInPx,
  // });

  // Add css variables to the cropper pre wrapper
  $cropperPreWrapper.css('--frame-wooden-width', `${frameWoodenWidthInPx}px`);
  $cropperPreWrapper.css(
    '--frame-aluminum-width',
    `${frameAluminumWidthInPx}px`,
  );
  $cropperPreWrapper.css('--passe-partout-width', `${passePartoutWidthInPx}px`);
  $cropperPreWrapper.css('--passe-partout-scale', `${passePartoutScaleFactor}`);
  $cropperPreWrapper.css(
    '--image-crop-offset-pp',
    `${imageCropOffsetPerSideForPPInPx}px`,
  );
}

function updateInputFromSelect($selectElement) {
  //console.log('updating inputs from select');
  const selectedDimensions = getDimensionsFromSelect($selectElement);

  x = selectedDimensions.x;
  y = selectedDimensions.y;

  //updateVisualizationData(x, y);

  $('#ppbs-widget [data-dimensionname="width"] input').val(x);
  $('#ppbs-widget [data-dimensionname="height"] input')
    .val(y)
    .trigger('input')
    .trigger('change');
}

function initPredefinedSizeSelects() {
  const $labelSelectedDimensions = $(
    '.predefined-sizes-selects-wrapper .selected-dimensions',
  );

  $('select.predefined-size').on('change', function () {
    userSelectedSize = $(this).val();
    $labelSelectedDimensions.text($(this).find('option:selected').text());
    updateInputFromSelect($(this));
  });
}

function initProductSizesPerVariants() {
  // global variables cfgProductSizes, productAttributes is defined in product-variants.tpl
  // global variables cropOrientations, imageOrientation is defined in productcustomization.tpl

  if (
    typeof cfgProductSizes === 'undefined' ||
    cfgProductSizes.length === 0 ||
    typeof productAttributes === 'undefined' ||
    productAttributes.length === 0
  ) {
    return;
  }

  //console.log({ cfgProductSizes, productAttributes });

  const $selectPredefinedOrientation = $('#predefined-orientation');
  const $labelSelectedOrientation = $(
    '.predefined-orientation-wrapper .selected-orientation',
  );
  const $listPredefinedOrientation = $('#predefined-orientation-list');
  const $selectPredefinedSizesVertical = $('#predefined-sizes-vertical');
  const $selectPredefinedSizesHorizontal = $('#predefined-sizes-horizontal');
  const $selectPredefinedSizesSquare = $('#predefined-sizes-square');
  const $predefinedSizesSelects = $('select.predefined-size');
  const $labelSelectedDimensions = $(
    '.predefined-sizes-selects-wrapper .selected-dimensions',
  );

  $predefinedSizesSelects.removeClass('active');

  // Reset options
  $selectPredefinedOrientation.find('option').remove();
  $listPredefinedOrientation.find('li').remove();
  $selectPredefinedSizesVertical.find('option').remove();
  $selectPredefinedSizesHorizontal.find('option').remove();
  $selectPredefinedSizesSquare.find('option').remove();

  let productSizesForCurrentVariant = {
    horizontal: [],
    vertical: [],
    square: [],
  };
  let variantStrings = [];

  const sizesPerVariants =
    cfgProductSizes.product_sizes.sizes_per_variants.filter(
      (v) => v.id_default_category == productIdCategoryDefault,
    );

  //console.log({ sizesPerVariants });

  productAttributes.forEach((attribute) => {
    variantStrings.push(
      /* `${attribute.id_attribute_group}_${attribute.id_attribute}` */
      attribute.id_attribute,
    );
  });

  let variantGroupAttrs = [];

  sizesPerVariants.forEach((sizePerVariant, index) => {
    variantGroupAttrs[index] = sizePerVariant.variants.map(
      (v) => v.variant_group_attr,
    );
  });

  let matchedSizesPerVariantsIndex = -1;

  const variantKey = variantStrings.join('_');

  //variantStrings.forEach((variant_key) => {
  variantGroupAttrs.forEach((groupAttrs, index) => {
    if (groupAttrs.includes(variantKey)) {
      matchedSizesPerVariantsIndex = index;
    }
  });
  //});

  if (matchedSizesPerVariantsIndex === -1) {
    return;
  }

  const matchedSizesPerVariant =
    sizesPerVariants[matchedSizesPerVariantsIndex].sizes_per_orientation;

  productSizesForCurrentVariant['vertical'] =
    matchedSizesPerVariant.vertical.map((v) => v.size);
  productSizesForCurrentVariant['horizontal'] =
    matchedSizesPerVariant.vertical.map((v) => {
      const dimensions = v.size.split('x');
      const width = parseInt(dimensions[0].replace(/\D/g, ''));
      const height = parseInt(dimensions[1].replace(/\D/g, ''));
      const unit = dimensions[1].replace(/\d/g, '');

      return `${height}x${width}${unit}`;
    });
  // Sort horizontal sizes by width then height
  productSizesForCurrentVariant['horizontal'].sort((a, b) => {
    const [aWidth, aHeight] = a
      .replace(/\s/g, '')
      .replace(/[^\d]/g, ' ')
      .trim()
      .split('x')
      .map(Number);
    const [bWidth, bHeight] = b
      .replace(/\s/g, '')
      .replace(/[^\d]/g, ' ')
      .trim()
      .split('x')
      .map(Number);

    if (aWidth === bWidth) {
      return aHeight - bHeight;
    }
    return aWidth - bWidth;
  });

  productSizesForCurrentVariant['square'] = matchedSizesPerVariant.square.map(
    (v) => v.size,
  );

  //console.log({ productSizesForCurrentVariant });

  // Populate orientation select
  Object.keys(productSizesForCurrentVariant).forEach((orientation) => {
    const sizes = productSizesForCurrentVariant[orientation];

    if (sizes.length > 0) {
      const orientationLabel =
        cropOrientations[orientation] !== undefined
          ? cropOrientations[orientation]
          : orientation;

      const optionElement = `<option value="${orientation}">${orientationLabel}</option>`;
      $selectPredefinedOrientation.append(optionElement);

      const listItem = `<li class="${orientation}" data-value="${orientation}">
      <span class="box-icon box-icon-${orientation}"></span>
      <span>${orientationLabel}</span>
    </li>`;

      $listPredefinedOrientation.append(listItem);
    }
  });

  // Attach click listeners to orientation list items
  $listPredefinedOrientation.find('li').on('click', function () {
    const selectedOrientation = $(this).data('value');

    $listPredefinedOrientation.find('li').removeClass('active');
    $listPredefinedOrientation
      .find(`li.${selectedOrientation}`)
      .addClass('active');

    userSelectedOrientation = selectedOrientation;

    $activeSizesSelect = $(`#predefined-sizes-${selectedOrientation}`);

    $labelSelectedOrientation.text(cropOrientations[selectedOrientation]);
    $labelSelectedDimensions.text(
      productSizesForCurrentVariant[selectedOrientation].includes(
        userSelectedSize,
      )
        ? userSelectedSize
        : $activeSizesSelect.val(),
    );

    $selectPredefinedOrientation.val(selectedOrientation).trigger('change');
  });

  // Set selected orientation based on imageOrientation global variable
  let $activeSizesSelect = null;
  const orientationToSelect = userSelectedOrientation
    ? userSelectedOrientation
    : imageOrientation;

  // console.log({
  //   imageOrientation,
  //   userSelectedOrientation,
  //   userSelectedSize,
  //   orientationToSelect,
  // });

  if (
    orientationToSelect &&
    productSizesForCurrentVariant[orientationToSelect] &&
    productSizesForCurrentVariant[orientationToSelect].length > 0
  ) {
    $selectPredefinedOrientation.val(orientationToSelect).trigger('change');
    $activeSizesSelect = $(`#predefined-sizes-${orientationToSelect}`);
    $listPredefinedOrientation.find('li').removeClass('active');
    $listPredefinedOrientation
      .find(`li.${orientationToSelect}`)
      .addClass('active');
    $labelSelectedOrientation.text(cropOrientations[orientationToSelect]);
    $labelSelectedDimensions.text(
      productSizesForCurrentVariant[orientationToSelect].includes(
        userSelectedSize,
      )
        ? userSelectedSize
        : productSizesForCurrentVariant[orientationToSelect][0],
    );
  } else {
    // Trigger change to set the first available orientation
    if (isCanvas) {
      $selectPredefinedOrientation.val('horizontal');
      $listPredefinedOrientation.find('li').removeClass('active');
      $listPredefinedOrientation.find('li.horizontal').addClass('active');
      $activeSizesSelect = $('#predefined-sizes-horizontal');
      $labelSelectedOrientation.text(cropOrientations['horizontal']);
      $labelSelectedDimensions.text(
        productSizesForCurrentVariant['horizontal'].includes(userSelectedSize)
          ? userSelectedSize
          : productSizesForCurrentVariant['horizontal'][0],
      );
    } else if (isPoster) {
      $selectPredefinedOrientation.val('vertical');
      $listPredefinedOrientation.find('li').removeClass('active');
      $listPredefinedOrientation.find('li.vertical').addClass('active');
      $activeSizesSelect = $('#predefined-sizes-vertical');
      $labelSelectedOrientation.text(cropOrientations['vertical']);
      $labelSelectedDimensions.text(
        productSizesForCurrentVariant['vertical'].includes(userSelectedSize)
          ? userSelectedSize
          : productSizesForCurrentVariant['vertical'][0],
      );
    } else {
      $selectPredefinedOrientation.trigger('change');
      const selectedOrientation = $selectPredefinedOrientation.val();
      $activeSizesSelect = $(`#predefined-sizes-${selectedOrientation}`);
    }
  }

  $activeSizesSelect.addClass('active');

  // Populate options
  Object.keys(productSizesForCurrentVariant).forEach((orientation) => {
    const sizes = productSizesForCurrentVariant[orientation];

    let $selectElement = null;

    if (orientation === 'vertical') {
      $selectElement = $selectPredefinedSizesVertical;
    } else if (orientation === 'horizontal') {
      $selectElement = $selectPredefinedSizesHorizontal;
    } else if (orientation === 'square') {
      $selectElement = $selectPredefinedSizesSquare;
    }

    sizes.forEach((size, index) => {
      const optionElement = `<option value="${size}" ${
        userSelectedSize === size || index === 0 ? 'selected' : ''
      }>${size}</option>`;
      $selectElement.append(optionElement);
    });
  });

  // Trigger change to update inputs

  updateInputFromSelect($activeSizesSelect);
}

function waitForCropperReady(timeout = 4000, interval = 50) {
  return new Promise((resolve) => {
    if (!cropper) {
      resolve(false);
      return;
    }

    if (isCropperReady) {
      resolve(true);
      return;
    }

    const start = Date.now();
    const timer = setInterval(() => {
      if (cropper && isCropperReady) {
        clearInterval(timer);
        resolve(true);
        return;
      }

      if (Date.now() - start >= timeout) {
        clearInterval(timer);
        resolve(false);
      }
    }, interval);
  });
}

$(document).ready(() => {
  initProductCustomizationButton();
  initProductCustomizationCloseButton();

  if (isCanvas || isPoster) {
    initProductSizesPerVariants();
    initPredefinedSizeSelects();
    toggleDimensionSelects();
  }

  // prestashop.on('updateProductList', () => {
  //   productCustomizationButton();
  // });

  attachCropperListeners();

  prestashop.on('updatedProductCombination', () => {
    if (isCanvas || isPoster) {
      initProductSizesPerVariants();
      initPredefinedSizeSelects();
      toggleDimensionSelects();
    }
  });
});

$(window).on('resize', function () {
  $('.cropper-pre-wrapper').removeClass('ready');
  initCropperResizeDebounce();
});

// $(window).on('scroll', function () {
//   initUpdateViewportHeightDebounce();
// });
